import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import Reveal, { Eyebrow } from "./Reveal";

const faqs = [
  ["La guida è davvero gratuita?", "Sì. Lasci nome ed email, la scarichi subito e ricevi 3 email con consigli pratici nei 7 giorni successivi. Puoi disiscriverti con un clic."],
  ["Devo andare in palestra?", "No. Gli esercizi della guida si possono fare a casa con un paio di manubri, un elastico o anche solo una bottiglia d'acqua."],
  ["Funziona se ho poco tempo?", "È pensata per questo. Ogni giorno richiede tra 10 e 40 minuti, e nessuna azione ti chiede di stravolgere la tua routine."],
  ["Cos'è la ricomposizione corporea?", "È perdere grasso e costruire muscolo insieme. La bilancia può muoversi poco, ma cambiano forma, tono e taglie."],
  ["Il coaching 1:1 funziona a distanza?", "Sì, tutto online: piano su misura, check-in video settimanale e supporto diretto. Se vuoi capire se fa per te, prenota la chiamata conoscitiva gratuita."],
];

export default function Faq() {
  return (
    <section className="py-24 sm:py-32" data-testid="faq-section">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-4">
          <Eyebrow>Domande</Eyebrow>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tight mt-4">Domande frequenti</h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map(([q, a], i) => (
              <AccordionItem key={q} value={`f${i}`} className="border-[#E5E1D8]">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="font-display text-xl sm:text-2xl text-left py-6 hover:no-underline">
                  {q}
                </AccordionTrigger>
                <AccordionContent className="text-[#5A625C] text-base leading-relaxed pb-6">{a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
